import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '@exchange/environment'
import { IModelBase } from 'common-components'
import { IReadyForPayment } from './readyForPaymentView'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { TmrODataConfiguration } from '../services/core/odata'
import { ODataService } from 'common-services'

export interface IPayment extends IModelBase {
  Details: IPaymentDetails
  ServiceLines: IReadyForPayment[]
}

export interface IPaymentDetails {
  PaymentDate: Date
  Amount: number
  Memo: string
  SenderName: string
}

export interface IElectronicFundsPayment extends IPayment {
  Details: IElectronicFundsPaymentDetails
}

export interface IElectronicFundsPaymentDetails extends IPaymentDetails {
  SenderIdentifier: string
  SenderRoutingNumber: string
  SenderAccountNumber: string
  ReceiverIdentifier: string
  ReceiverRoutingNumber: string
  ReceiverName: string
  ReceiverAccountNumber: string
}

export enum PaymentType {
  INFO = 'INFO',
  CHK = 'CHK',
  EFT = 'ETF'
}

const bulkUri = `${environment.rmapiroot}/RemittanceActions/Bulk`
const checkPaymentUrl = `${bulkUri}/Pay/Check`
const etfPaymentUrl = `${bulkUri}/Pay/Electronic`
const informationalPaymentUrl = `${bulkUri}/Pay/Informational`
const returnToInventoryUrl = `${bulkUri}/ReturnToInventory`

@Injectable()
export class PaymentService {
  private reqOptions: { headers: HttpHeaders }

  constructor(protected http: HttpClient) {
    this.http = http

    this.reqOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json'
      })
    }
  }

  makeCheckPayment(payment: IPayment): Observable<object> {
    return this.http.post(checkPaymentUrl, payment, this.reqOptions)
  }

  makeETFPayment(payment: IElectronicFundsPayment): Observable<object> {
    return this.http.post(etfPaymentUrl, payment, this.reqOptions)
  }

  makeInformationalPayment(payment: IPayment): Observable<object> {
    return this.http.post(informationalPaymentUrl, payment, this.reqOptions)
  }

  returnToInventory(serviceLines: IReadyForPayment[]): Observable<object> {
    return this.http.post(returnToInventoryUrl, serviceLines, this.reqOptions)
  }
}

@Injectable()
export class PaymentODataService extends ODataService<IPayment> {
  constructor(
    protected http: HttpClient,
    protected config: TmrODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'Payment'
  }
}
